// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coming-soon-container {
  width: 100%;
  display: flex;
  background-color: var(--base_color2);
  height: 400px;
  margin: 10px auto;
  align-items: center;
  justify-content: center;
}
.coming-soon-container .Illustration {
  width: 200px;
  height: 200px;
  margin-right: 20px;
}
.coming-soon-container h5 {
  font-size: 36px;
  line-height: 45px;
  margin: 0;
  color: var(--gray_dark1);
}
.coming-soon-container p {
  font-size: 20px;
  line-height: 25px;
  color: var(--gray);
  margin: 0;
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/ComingSoonMessage/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AACJ;AAEE;EACE,eAAA;EACA,iBAAA;EACA,SAAA;EACA,wBAAA;AAAJ;AAGE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AADJ","sourcesContent":[".coming-soon-container {\n  width: 100%;\n  display: flex;\n  background-color: var(--base_color2);\n  height: 400px;\n  margin: 10px auto;\n  align-items: center;\n  justify-content: center;\n\n  .Illustration {\n    width: 200px;\n    height: 200px;\n    margin-right: 20px;\n  }\n\n  h5 {\n    font-size: 36px;\n    line-height: 45px;\n    margin: 0;\n    color: var(--gray_dark1);\n  }\n\n  p {\n    font-size: 20px;\n    line-height: 25px;\n    color: var(--gray);\n    margin: 0;\n    margin-top: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
